import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=37273de6&"
import script from "./Award.vue?vue&type=script&lang=js&"
export * from "./Award.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports